class GaugeConfig extends BaseItemConfig {
    metric: KnockoutObservable<number>;
    target: KnockoutObservable<number>;
    formattingRule: KnockoutObservable<number>;
    comparisonFilter: ComparisonFilter;

    type: KnockoutObservable<GaugeTypeEnum>;
    endValue: KnockoutObservable<number>;
    showIndicatorValue: KnockoutObservable<GaugeShowIndicatorValueEnum>;
    size: KnockoutObservable<number>;
    tick: KnockoutObservable<boolean>;
    tickIntervalType: KnockoutObservable<GaugeTickIntervalTypeEnum>;
    tickIntervalValue: KnockoutObservable<number>;

    indicatorFormat: GaugeIndicatorFormat;
    scalesFormat: GaugeScaleFormat

    format: KnockoutObservable<FieldFormatEnum>;
    accountingStyle: KnockoutObservable<number>;

    fontSize: KnockoutObservable<number>;

    constructor(data: any) {
        super(data);

        this.metric = ko.observable(data.metric);
        this.target = ko.observable(data.target);
        this.formattingRule = ko.observable(data.formattingRule);

        this.comparisonFilter = new ComparisonFilter(data.comparisonFilter);

        this.type = ko.observable(data.type);
        this.endValue = ko.observable(data.endValue);
        this.showIndicatorValue = ko.observable(data.showIndicatorValue);
        this.size = ko.observable(data.size);
        this.tick = ko.observable(data.tick);
        this.tickIntervalType = ko.observable(data.tickIntervalType);
        this.tickIntervalValue = ko.observable(data.tickIntervalValue);

        this.indicatorFormat = new GaugeIndicatorFormat(data.indicatorFormat);
        this.scalesFormat = new GaugeScaleFormat(data.scalesFormat);

        this.format = ko.observable(data.format);
        this.accountingStyle = ko.observable(data.accountingStyle);
        this.fontSize = ko.observable(data.fontSize);
    }

    get allowDetailTab(): boolean {
        return true;
    }
}

enum GaugeTypeEnum {
    Circular = "circular",
    Bar = "bar"
}
enum GaugeCircularIndicatorTypeEnum {
    Needle = "twoColorNeedle",
    Triangle = "triangleMarker"
}
enum GaugeShowIndicatorValueEnum {
    None = "none",
    Middle = "middle"
}
enum GaugeTickIntervalTypeEnum {
    Value = "value",
    Percentual = "percentual"
}
enum GaugeScalePositionEnum {
    Inside = "inside",
    Outside = "outside"
}

class GaugeIndicatorFormat {
    unitFormat: KnockoutObservable<LabelFormatEnum>;
    decimalPlaces: KnockoutObservable<number>;

    constructor(data){
        this.unitFormat = ko.observable(data.unitFormat);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
    }
}

class GaugeScaleFormat {
    unitFormat: KnockoutObservable<LabelFormatEnum>;
    decimalPlaces: KnockoutObservable<number>;
    position: KnockoutObservable<GaugeScalePositionEnum>;
    labelColor: KnockoutObservable<string>;
    labelFontSize: KnockoutObservable<number>;

    constructor(data) {
        this.unitFormat = ko.observable(data.unitFormat);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.position = ko.observable(data.position);
        this.labelColor = ko.observable(data.labelColor);
        this.labelFontSize = ko.observable(data.labelFontSize);
    }
}